import { StylessButton } from './styles/button.style';
import { NewButton } from './styles/newButton';

const isoButton = NewButton;
isoButton.StylessButton = StylessButton;

export default isoButton;
